import type { ValueItem } from "./types";
import type { CreateCategoryAttributeRequest } from "@/services/api";

export function prepareAttributeValues(
  values: ValueItem[]
): CreateCategoryAttributeRequest["values"] {
  return values
    .map((v, index) => ({
      value: v.value.trim(),
      order: index + 1,
    }))
    .filter((v) => v.value.length > 0);
}

export function validateAttributeData(
  name: string,
  values: ValueItem[]
): boolean {
  return (
    name.trim().length > 0 &&
    values.some((v) => v.value.trim().length > 0)
  );
}

